Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typeValidation = require('./typeValidation');

var _typeValidation2 = _interopRequireDefault(_typeValidation);

require('@pcty/inset-banner/lib/css/index.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PctyInsetBanner = function PctyInsetBanner(_ref) {
  var id = _ref.id,
      type = _ref.type,
      title = _ref.title,
      icon = _ref.icon,
      visible = _ref.visible,
      onDismiss = _ref.onDismiss,
      children = _ref.children,
      __TYPE = _ref.__TYPE;

  if (!visible) return null;

  return _react2.default.createElement(
    'div',
    { className: getWrapperCssClasses(type) },
    _react2.default.createElement(
      'div',
      { className: 'pcty-banner-column pcty-icon-column' },
      renderIcon(icon)
    ),
    _react2.default.createElement(
      'div',
      { className: 'pcty-banner-column pcty-banner-message' },
      renderTitle(title),
      children
    ),
    renderDissmiss(id, onDismiss)
  );
};

var getWrapperCssClasses = function getWrapperCssClasses(type) {
  return type === 'basic' ? 'pcty-inset-banner' : 'pcty-inset-banner pcty-' + type;
};

var renderIcon = function renderIcon(icon) {
  if (icon === null || icon === undefined) return _react2.default.createElement('i', { className: 'pcty-banner-icon' });

  return _react2.default.createElement('i', { className: 'pcty-icon-' + icon + ' pcty-size-medium' });
};

var renderTitle = function renderTitle(title) {
  if (title === null || title === undefined) return null;

  return _react2.default.createElement(
    'h3',
    { className: 'pcty-banner-title' },
    title
  );
};

var renderDissmiss = function renderDissmiss(id, onDismiss) {
  if (onDismiss === null || onDismiss === undefined) return null;

  return _react2.default.createElement(
    'span',
    { className: 'pcty-banner-column pcty-action-column' },
    _react2.default.createElement('a', { className: 'pcty-banner-dismiss', onClick: function onClick() {
        return onDismiss(id);
      } })
  );
};

PctyInsetBanner.defaultProps = {
  type: 'basic',
  visible: true,
  onDismiss: null,
  __TYPE: 'PctyInsetBanner'
};

PctyInsetBanner.propTypes = {
  id: _propTypes2.default.string.isRequired,
  /** The type of banner to display. */
  type: _propTypes2.default.oneOf(['basic', 'information', 'success', 'warning', 'error']),
  /** The text title to display. */
  title: _propTypes2.default.string,
  /** The name of a custom icon to use. Use the icon name rather than the full class name. For example: "calculator" instead of "pcty-calculator" */
  icon: _propTypes2.default.string,
  /** Whether or not the banner is displayed. */
  visible: _propTypes2.default.bool,
  /** { description: "Callback function for when a user clicks the dismiss button.", validValues: "any function with (id) as a named param" } */
  onDismiss: _propTypes2.default.func,
  /** Markup that should be displayed as the message of the component. If just using text, it's recommended to wrap your message in " " tags so it will line up properly with the icon. */
  children: _propTypes2.default.node,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation2.default)(props, propName, componentName, 'PctyInsetBanner');
  }
};

exports.default = PctyInsetBanner;